import Vue from 'vue'
import VueRouter from 'vue-router'
import { urlSearchObj } from "@/utils/util";

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'index',
    component: () => import('../views/index.vue')
  },
  {
    path: '/login',
    name: 'login',
    component: () => import('../views/login.vue')
  },
  {
    path: '/bkReg',
    name: 'bkReg',
    component: () => import('../views/bkReg.vue')
  },
  {
    path: '/register',
    name: 'register',
    component: () => import('../views/register.vue')
  },
  {
    path: '/experience',
    name: 'experience',
    component: () => import('../views/experience.vue')
  },
  {
    path: '/guide',
    name: 'guide',
    component: () => import('../views/guide.vue')
  },
  {
    path: '/mine',
    name: 'mine',
    component: () => import('../views/mine.vue')
  },
  {
    path: '/bindName',
    name: 'bindName',
    component: () => import('../views/bindName.vue')
  },
  {
    path: '/experSuc',
    name: 'experSuc',
    component: () => import('../views/experSuc.vue')
  },
  {
    path: '/recommend',
    name: 'recommend',
    component: () => import('../views/recommend.vue')
  },
  {
    path: '/experInfo',
    name: 'experInfo',
    component: () => import('../views/experInfo.vue')
  },
  {
    path: '/applyDelay',
    name: 'applyDelay',
    component: () => import('../views/applyDelay.vue')
  },
  {
    path: '/applyNoDelay',
    name: 'applyNoDelay',
    component: () => import('../views/applyNoDelay.vue')
  },
  {
    path: '/live',
    name: 'live',
    component: () => import('../views/live.vue')
  },
  {
    path: '/changePwd',
    name: 'changePwd',
    component: () => import('../views/changePwd.vue')
  },
]

const router = new VueRouter({
  // mode: 'history',
  base: process.env.BASE_URL,
  routes
})

router.beforeEach((to, from, next) => {
  //beforeEach是router的钩子函数，在进入路由前执行
  const { id } = urlSearchObj();
  if(id == 2261) {
    document.title = `三楼智慧服务`
  }
  next()
})
export default router
